import { Dropdown, Field, Option } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

interface IEmploymentStatusDropdownProps {
    selectedEmploymentStatusId: string | number;
    isDisabled: boolean;
    onEmploymentStatusChange: (employmentStatusId: string) => void;
}

interface IEmploymentStatusOption {
    id: number;
    key: string;
}

const employmentStatusOptions: IEmploymentStatusOption[] = [
    { id: 1, key: "employed" },
    { id: 2, key: "partTime" },
    { id: 3, key: "selfEmployed" },
    { id: 4, key: "homemaker" },
    { id: 5, key: "unemployed" }
];

export default function EmploymentStatusDropdown(props: IEmploymentStatusDropdownProps) {
    const { t } = useTranslation('recruitment');

    const selectedEmploymentStatusId = props.selectedEmploymentStatusId?.toString() ?? "";
    const selectedOption = employmentStatusOptions.find(option => option.id.toString() === selectedEmploymentStatusId);
    const selectedLabel = selectedOption
        ? t(`register.form.employmentOptions.${selectedOption.key}`)
        : t("register.form.selectEmploymentStatus");

    const handleEmploymentStatusSelected = (value?: string) => {
        if (value && employmentStatusOptions.some(option => option.id.toString() === value)) {
            props.onEmploymentStatusChange(value);
        }
    };

    return (
        <Field label={t("register.form.employmentStatus")} style={{ flex: 1 }} required>
            <Dropdown
                value={selectedLabel}
                disabled={props.isDisabled}
                selectedOptions={[selectedEmploymentStatusId]}
                onOptionSelect={(_, data) => handleEmploymentStatusSelected(data.optionValue)}
            >
                {employmentStatusOptions.map(option =>
                    <Option key={option.id} value={option.id.toString()}>
                        {t(`register.form.employmentOptions.${option.key}`)}
                    </Option>
                )}
            </Dropdown>
        </Field>
    );
}